<script lang="ts">
import { navigate, useParams } from "svelte-navigator";
import Credentials from "../components/Credentials.svelte";
import { authService } from "../services";
import { startSession, isLoggedIn } from "../services/session";
import { onMount } from "svelte";
import Footer from "../components/Footer.svelte";

    const params = useParams(); 
    
    onMount(() => {
        if (isLoggedIn()) {
            navigate('/');
        }

        if ($params.id) {
           login($params.id) 
        }
    })

    async function login(accessToken) {
        const newAccessToken = await authService.getToken(accessToken);   
        await startSession(newAccessToken);
        navigate('/');
    }


</script>



<style lang="scss">

    .body-html {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        padding-bottom: 40px;
        max-width: 360px;
        margin: auto;
    }


    .form-floating{
        width: 100%;
        max-width: 275px;
        margin: auto;
        position: relative;

        .phantom{
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }

        :global(button){
            min-height: 50px;
            border-radius: 5px !important;
            font-weight: bold !important;
        }
        :global(span){
            display: none;
        }
        :global(.facebook-auth){
            margin-top: 20px;
            background-color: #3B5998 !important;
            
            :global(img){
                display: none;
            }

            &::after{
                content: 'Acceder con Facebook';
                color: white !important;
                margin-left: 5px;
            }
        }

        :global(.google-auth){
            background-color: #CF2F2C !important;
            :global(img){
                display: none;
            }

            &::after{
                content: 'Acceder con Gmail';
                color: white !important;
                margin-left: 5px;
            }
        }
    }




</style>

<div class="body-html">
    <div class="row text-center">
        <div class="col-12">
            <h1 class="mb-3">Bienvenido</h1>

            <div class="text-center">                



            </div>
     
        </div>
        <p class="mt-2 mb-3 text-muted"><Credentials /></p>
    </div>
</div>

<Footer/>